import { makePublishHelper, makeSubscribeHelper } from '../../helpers-creators';

export var event3DSecureRequested = makePublishHelper('event3DSecureRequested', 'wh.common.event.ui.header.deposit.3d-secure-payment-journey-required');

export var onEvent3DSecureRequested = makeSubscribeHelper('onEvent3DSecureRequested', 'wh.common.event.ui.header.deposit.3d-secure-payment-journey-required');
//# sourceMappingURL=event3DSecureRequested.js.map